import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { selectUser } from "../../stores";
import { urls } from "../../urls";

export const RequireAuth = ({ children }) => {
  const user = useSelector(selectUser);
  const location = useLocation();

  return user ? children
    : <Navigate replace to={ urls.login() } state={ { from: location } } />;
};
